async function montaListaImoveis(resultImoveis) {
  let arrayImoveis = [];
  if (resultImoveis.length > 0) {
    resultImoveis.forEach((imovel) => {
      arrayImoveis.push({
        nome: imovel.NomeImovel,
        id: imovel.assetIdSalesFoce,
        contratos: imovel.contratos,
        empreendimentoId: imovel.empreendimento.empreendimentoIdSalesForce,
        entregaChaves: imovel.EntregaChave || "Sem entrega",
        vistoria: imovel.Vistoria,
        numero: imovel.nome.split("-")[1],
        tipoEmpreendimento: imovel.empreendimento.holding.nome,
        oportunidadeIdSalesForce: imovel.OportunidadeIdSalesForce,
      });
    });
  }
  return arrayImoveis;
}

async function returnImovelSelecionado(array, imovel) {
  let resultFilterImovel = await array.filter((item) => {
    return item.nome == imovel;
  });
  return resultFilterImovel;
}

async function returnContratoImovelSelecionado(arrayImovelSelecionado) {
  let resultGetContrato = await arrayImovelSelecionado[0].contratos.filter(
    (contrato) => {
      return contrato.status == "Ativado";
    }
  );
  if (resultGetContrato.length == 0) return "";
  else return resultGetContrato[0].contratoIdSalesforce;
}

export {
  montaListaImoveis,
  returnImovelSelecionado,
  returnContratoImovelSelecionado,
};
